import { Popover, PopoverContent, PopoverTrigger } from '@neo/primitives/popover'
import { Tooltip } from '@neo/primitives/tooltip'
import { Music } from 'lucide-react'
import { useState } from 'react'
import { AudioUploadCore } from './audio-upload-core'

interface AudioUploadCardProps {
  url: string
  onURLChange: (url: string, name: string) => void
}
export const AudioUploadCard: React.FC<AudioUploadCardProps> = ({ url: dataURL, onURLChange }) => {
  const [open, setOpen] = useState(false)
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <Tooltip content="Attach audio file">
        <PopoverTrigger asChild>
          <div className="pointer">
            <Music size={16} className={open ? 'text-brand-text' : 'text-tertiary'} />
          </div>
        </PopoverTrigger>
      </Tooltip>

      <PopoverContent side="top" className="w-[330px] p-3">
        <div className="text-xxs-600 uppercase mb-3 text-secondary">Add audio prompt</div>
        <AudioUploadCore url={dataURL} onURLChange={onURLChange} />
      </PopoverContent>
    </Popover>
  )
}
